"use client";
import React from "react";

interface WuscaherosectionProps {
  bannerImage?: string;
  altText?: string;
  logoImage?: string;
  logoAltText?: string;
}

const Wuscaherosection = ({
  bannerImage,
  altText,
  logoImage,
  logoAltText,
}: WuscaherosectionProps) => {
  return (
    <>
      <section className="relative overflow-hidden h-[400px]">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-no-repeat bg-[position:-165px_0] md:bg-[position:0] lg:bg-[position:0_-130px]"
          style={
            bannerImage
              ? { backgroundImage: `url('${bannerImage}')` }
              : undefined
          }
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient18" />
        {/* Content */}
        <div className="absolute inset-0 flex items-center justify-center w-full h-full">
          {/* WUSCA Logo */}
          {logoImage && (
            <div className="w-[120px] h-[120px] flex items-center justify-center">
              <img
                src={logoImage}
                alt={logoAltText || altText || "Whatuni Student Choice Awards"}
                width={91}
                height={77}
                className="object-contain"
              />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Wuscaherosection;
